import { EntityState } from '@ngrx/entity';
import { Role } from '../role/role.model';

// MOVE TO AUTH
export enum EmailErrorMessage {
  EMAIL_DOMAIN = 'Email domain is not valid',
  EMAIL_REQUIRED = 'Email is required',
  IS_NOT_EMAIL = 'Please enter a valid email address',
}

export interface LookupCriteria {
  clientInfoId: number;
  email?: string;
  lastName?: string;
  status?: UserStatus;
  userName?: string;
}

// MOVE TO AUTH
export enum PasswordErrorMessage {
  CONFIRM_PASSWORD_REQUIRED = 'Confirm new password is required',
  IS_NOT_PASSWORD = 'Please enter a valid password',
  NEW_PASSWORD_REQUIRED = 'New password is required',
  PASSWORD_MUST_MATCH = 'The New Password and Confirm New Password fields do not match',
  PASSWORD_REQUIRED = 'Password is required',
}

export interface ProvinceModel {
  id: number;
  code: string;
  description: string;
}

// MOVE TO AUTH
export interface ResetPasswordModel {
  id: number;
  newPassword: string;
}

export enum UserErrorMessage {
  CORPORATION_REQUIRED = 'Corporation is required',
  FIRST_NAME_MAX_LENGTH = 'Maximum length of First Name is ',
  FIRST_NAME_REQUIRED = 'First Name is required',
  IS_NOT_PHONE_EXTENSION = 'Please enter a valid extension number',
  IS_NOT_PHONE_NUMBER = 'Please enter a valid phone number',
  LANGUAGE_REQUIRED = 'Language is required',
  LAST_NAME_MAX_LENGTH = 'Maximum length of Last Name is ',
  LAST_NAME_REQUIRED = 'Last Name is required',
  MIDDLE_NAME_MAX_LENGTH = 'Maximum length of Middle Name is ',
  MIDDLE_NAME_WHITESPACE = 'Please enter a valid Middle Name',
  NO_RECORD = 'No records available',
  PROVINCE_REQUIRED = 'Province is required',
  ROLE_REQUIRED = 'Role is required',
  USER_NAME_EXISTS = 'User name already exists. Please try again',
  USER_NAME_REQUIRED = 'User Name is required',
}

export enum UserStatus {
  active = 'Active',
  disabled = 'Disabled',
  inactive = 'Inactive',
}

export interface UserModel {
  changePasswordDateUtc?: Date;
  clientInfoId?: number;
  createdDate?: Date;
  description?: string;
  email?: string;
  firstName?: string;
  forcePassword?: boolean;
  id: number;
  isenabled?: boolean;
  isDeleted?: boolean;
  isLocked?: boolean;
  language?: string;
  lastLoginDateUtc?: Date;
  lastName?: string;
  lastUpdatedBy?: string;
  middleName?: string;
  name?: string;
  password?: string;
  phone?: string;
  policyAgreedDateUtc?: Date;
  provinceId?: number;
  roleDisplayName?: string;
  roleId?: number;
  status?: UserStatus;
  userName?: string;
}

export interface UserList {
  roles: Role[];
  users: UserModel[];
}

export interface UserPreferences {
  dashboardComponentName: string;
  dashboardPreferences: string;
}

export interface UserState extends EntityState<UserModel> {
  error: string;
  loaded: boolean;
  loading: boolean;
  selectedUserId: number | null;
}
